import TemplateSelectorBuilder from '@lit-any/core/template-registry/TemplateSelectorBuilder';
import FieldTemplateSelector from './TemplateSelector';
// eslint-disable-next-line max-len
export default class FieldTemplateSelectorBuilder extends TemplateSelectorBuilder {
    // eslint-disable-next-line no-useless-constructor
    constructor(registry) {
        super(registry);
        this._getComponents = () => registry.components;
    }
    fieldMatches(fieldMatchFunc) {
        this._selector.push(constraint => {
            if (!constraint.field) {
                return false;
            }
            return fieldMatchFunc(constraint.field);
        });
        return this;
    }
    // eslint-disable-next-line class-methods-use-this
    _createSelector() {
        return new FieldTemplateSelector();
    }
    rendersComponent(component) {
        if (!component.options) {
            throw new Error(`Missing settings for component ${component.name}`);
        }
        return this.renders((...args) => {
            const components = this._getComponents();
            if (!components) {
                throw new Error('No component set configured');
            }
            const componentFunc = components[component.name] || components.textbox;
            if (!componentFunc) {
                throw new Error('No suitable component found');
            }
            return componentFunc(component.options)(...args);
        });
    }
}
